<div class="ascend-gantt-host" [class.is-sprint-month]="viewType === 'sprintMonth'" [attr.id]="domId" [style.minHeight.px]="height">
  <!-- Left panel: task details table -->
  <div class="ascend-gantt-left" [style.width.px]="leftPanelWidth">
    <div class="ascend-gantt-left-inner" [class.is-single-column]="singleColumn">
      <!-- Single "Sprint Data" column layout -->
      <ng-container *ngIf="singleColumn; else multiColumnHeader">
        <div class="ascend-gantt-header">
          <span class="col-sprint-data">{{ singleColumnHeader }}</span>
        </div>
        <div class="ascend-gantt-rows">
          <div *ngFor="let row of displayRows"
               class="ascend-gantt-row"
               [style.height.px]="rowHeight"
               [class.is-parent]="row.hasChildren"
               [class.is-child]="row.depth > 0">
            <span class="col-sprint-data" [style.paddingLeft.px]="12 + row.depth * 16">
              <span *ngIf="row.hasChildren" class="expand-icon" (click)="onToggleExpand(row)">
                {{ row.isExpanded ? '▼' : '▶' }}
              </span>
              <span class="phase-text">
                <span class="phase-title">{{ row.title }}</span>
                <span class="phase-range">{{ row.startLabel }} - {{ row.endLabel }}</span>
              </span>
            </span>
          </div>
        </div>
      </ng-container>

      <!-- Default multi-column layout -->
      <ng-template #multiColumnHeader>
        <div class="ascend-gantt-header">
          <span class="col-phase">Phases</span>
          <span class="col-duration">Duration/Sprints</span>
          <span class="col-start">Start Date</span>
          <span class="col-end">End Date</span>
        </div>
        <div class="ascend-gantt-rows">
          <div *ngFor="let row of displayRows; let i = index"
               class="ascend-gantt-row"
               [style.height.px]="rowHeight"
               [class.is-parent]="row.hasChildren"
               [class.is-child]="row.depth > 0">
            <span class="col-phase" [style.paddingLeft.px]="12 + row.depth * 16">
              <span *ngIf="row.hasChildren" class="expand-icon" (click)="onToggleExpand(row)">
                {{ row.isExpanded ? '▼' : '▶' }}
              </span>
              <span class="phase-text">
                <span class="phase-title">{{ row.title }}</span>
                <span class="phase-range">{{ row.hasChildren ? (row.startLabel + ' - ' + row.endLabel) : '-' }}</span>
              </span>
              <button *ngIf="showEditIcon && !row.hasChildren && row.depth > 0 && !readonly" 
                      class="edit-icon-btn" 
                      (click)="onEditIconClick($event, row)"
                      type="button">
                <img [src]="editIconSrc" alt="Edit">
              </button>
            </span>
            <span class="col-duration">{{ (row.hasChildren || row.depth === 0) ? '' : row.durationSprints }}</span>
            <span class="col-start">{{ row.hasChildren ? '' : row.startLabel }}</span>
            <span class="col-end">{{ row.hasChildren ? '' : row.endLabel }}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Resizable divider -->
  <div class="ascend-gantt-divider" (mousedown)="onDividerMouseDown($event)"></div>

  <!-- Right panel: chart -->
  <div class="ascend-gantt-right">
    <div #chartDiv class="ascend-gantt-chart"></div>
  </div>
</div>
